import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // 1. Show loading screen while checking authentication status
  if (loading) {
    return (
      <div className="min-h-screen bg-[#1a0b2e] flex items-center justify-center">
        <div className="text-accent-gold text-xl animate-pulse">
          Authenticating...
        </div>
      </div>
    );
  }

  // 2. If not logged in, redirect to Login page
  // We pass 'state' so we can redirect them back after they login (optional future feature)
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 3. If logged in, render the protected page
  return children;
};

export default ProtectedRoute;